<onyx-map></onyx-map>

<onyx-information-list>
  @for (
    pointOfInterest of contractor().pointsOfInterest;
    track pointOfInterest.pointOfInterest.uuid
  ) {
    @let point = pointOfInterest.pointOfInterest;
    <onyx-information-row [label]="point.name">
      <onyx-address
        [address]="point.address"
        format="full"
        [showFlag]="true"
      ></onyx-address>

      <div class="modal">
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="24"
          icon="side-modal-filled"
          (click)="openModal(pointOfInterest.pointOfInterest)"
        ></onyx-icon-button>
      </div>
    </onyx-information-row>
  }
</onyx-information-list>
